function isTruthyAdminFlag(value) {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return normalized === "true" || normalized === "1" || normalized === "admin";
}

function userIsMarkedAdmin(user) {
  if (!user) return false;
  const app = user.app_metadata || {};
  const meta = user.user_metadata || {};

  return (
    app.role === "admin" ||
    app.is_admin === true ||
    isTruthyAdminFlag(app.is_admin) ||
    isTruthyAdminFlag(app.admin) ||
    meta.role === "admin" ||
    meta.is_admin === true ||
    isTruthyAdminFlag(meta.is_admin) ||
    isTruthyAdminFlag(meta.admin)
  );
}

/**
 * @param {import("@supabase/supabase-js").User | null} user
 */
export function userIsAdmin(user) {
  return userIsMarkedAdmin(user);
}

/**
 * @param {import("@supabase/supabase-js").User | null} user
 */
export function userMaySeeActivitiesImportNav(user) {
  return userIsMarkedAdmin(user);
}

/**
 * @param {import("@supabase/supabase-js").User | null} user
 */
export function userMayUseActivitiesImportPage(user) {
  return userMaySeeActivitiesImportNav(user);
}

// Backward-compatible aliases
export const userMaySeeGzImportNav = userMaySeeActivitiesImportNav;
export const userMayUseGzImportPage = userMayUseActivitiesImportPage;
